/**
 * Original 8x8 pixel-art head "in the style of" the default Minecraft player (brown hair, tan skin,
 * blue eyes). Drawn here from scratch: no Mojang texture is downloaded or bundled. Used where a
 * player's real skin is missing or fails to load (e.g. on the compass).
 */
const PALETTE: Record<string, string> = {
  H: '#3f2a1a', // hair
  h: '#2c1d11', // hair, darker strands
  S: '#c48e6b', // skin
  s: '#ad7957', // skin, shade
  W: '#f2f2f2', // eye white
  B: '#3d4fa8', // iris
  N: '#8a5638', // nose
  M: '#5e3a24', // mouth / stubble
};

/** Rows top to bottom, one letter per pixel (see PALETTE). */
export const STEVE_PIXELS: readonly string[] = [
  'HHhHHHhH',
  'HHHHHHHH',
  'HSSSSSSH',
  'SSSSSSSS',
  'SWBSSBWS',
  'sSSNNSSs',
  'SSMMMMSS',
  'sSSSSSSs',
];

/** The same head as an SVG fragment (8x8 user units), to embed in another SVG. */
export function SteveRects() {
  return (
    <>
      {STEVE_PIXELS.map((row, y) =>
        [...row].map((c, x) => <rect key={`${x}-${y}`} x={x} y={y} width={1} height={1} fill={PALETTE[c]} />),
      )}
    </>
  );
}
